import i18njson from '../locales/i18n.json'

import { getBrowserLocale, getPrefferedLocal } from './locale'

const supportedTranslations = new Map()

type languageType = 'en'

interface ILanguages {
  en: string
}

interface ITranslations extends ILanguages {
  Key: string
}

function separateLocales(translations: ITranslations[]) {
  translations.forEach((translation) => {
    const key = translation['Key']
    for (const prop in translation) {
      if (prop !== 'Key') {
        const locale = prop
        const i18nJson = supportedTranslations.get(locale) ? supportedTranslations.get(locale) : {}
        const language: languageType = prop as languageType
        i18nJson[key] = translation[language] as string
        supportedTranslations.set(locale, i18nJson)
      }
    }
  })
}

separateLocales(i18njson['Sheet 1'])

const getTranslations = (key: string, localeDetails = false) => {
  const browserLocale = getBrowserLocale()
  const locale = getPrefferedLocal(browserLocale, supportedTranslations)

  const activeTranslation = supportedTranslations.get(locale)
  const localizedString = activeTranslation[key] ? activeTranslation[key] : key
  if (localeDetails) return locale
  else return localizedString
}

export const t = getTranslations
